// extracted by mini-css-extract-plugin
module.exports = {"sitewideAlertBanner":"az__xc","sitewideAlertBannerIconWrapper":"az_ayc","sitewideAlertBannerIcon":"az_byc","sitewideAlertBannerText":"az_cyc"};